module.exports = __webpack_public_path__ + "static/media/sun_protection@3x.523f8cdc.png";